import { render, staticRenderFns } from "./seed.vue?vue&type=template&id=c2d86c2a&scoped=true&"
import script from "./seed.vue?vue&type=script&lang=js&"
export * from "./seed.vue?vue&type=script&lang=js&"
import style0 from "./seed.vue?vue&type=style&index=0&id=c2d86c2a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2d86c2a",
  null
  
)

export default component.exports